import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import DashboardHome from '../components/dashboard/DashboardHome';
import AnalyticsPage from '../components/dashboard/AnalyticsPage';
import NotificationsPage from '../components/dashboard/NotificationsPage';
import HistoricalDataPage from '../components/dashboard/HistoricalDataPage';
import ExportDataPage from '../components/dashboard/ExportDataPage';
import SettingsPage from '../components/dashboard/SettingsPage';
import UserManagementPage from '../components/dashboard/UserManagementPage';
import ProtectedRoute from '../components/ProtectedRoute';
const Dashboard: React.FC = () => {
  const {
    isAdmin
  } = useAuth();
  const navigate = useNavigate();
  return <Routes data-id="element-460">
      <Route path="/" element={<DashboardHome data-id="element-462" />} data-id="element-461" />
      <Route path="/analytics" element={<AnalyticsPage data-id="element-464" />} data-id="element-463" />
      <Route path="/notifications" element={<NotificationsPage data-id="element-466" />} data-id="element-465" />
      <Route path="/history" element={<HistoricalDataPage data-id="element-468" />} data-id="element-467" />
      <Route path="/export" element={<ExportDataPage data-id="element-470" />} data-id="element-469" />
      {/* Admin-only routes */}
      <Route path="/settings" element={<ProtectedRoute requireAdmin data-id="element-472">
            <SettingsPage data-id="element-473" />
          </ProtectedRoute>} data-id="element-471" />
      <Route path="/users" element={<ProtectedRoute requireAdmin data-id="element-475">
            <UserManagementPage data-id="element-476" />
          </ProtectedRoute>} data-id="element-474" />
      {/* Fallback route */}
      <Route path="*" element={<div data-id="element-478">Page not found</div>} data-id="element-477" />
    </Routes>;
};
export default Dashboard;